module.exports = __webpack_public_path__ + "static/img/rosetten.a14d07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat/rosetten.png
// module id = Xn8e
// module chunks = 1